module.exports = __webpack_public_path__ + "static/media/arrow_set_page.ff840027.svg";